import React, { useContext } from 'react';
import { PinApi } from '../../../../../redux/api/PinApi';
import { IUserProfile } from '../../../../../types/User/IUserProfile';
import { RevUserContext } from '../../../../../context/UserContext';
import { Link, useParams } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';
import { ITicket } from '../../../../../types/Ticket/ITicket';

const Dockbar: React.FC<ITicket> = (ticket) => {
    const [selected, setSelected] = React.useState(0);
    const profile = useContext<IUserProfile>(RevUserContext)
    var { data } = PinApi.useGetPinsQuery(undefined, { skip: !profile?.Features?.Pin_Dock });
    //get the ticket Id from the route variable
    const { ticketId } = useParams()


    if (!profile?.Features?.Pin_Dock)
        return <></>;

    const handleSelect = e => {
        setSelected(e.selected);
    };
    //Bootstrap tabs
    return (
        <div className='d-none d-lg-block'>
            {/* <ul className='dock-bar'>
                {data?.map((p) =>
                    <li><Link to={`/ticket/${p.Call_Id}`}>{p.Call_Id}</Link></li>
                )}
            </ul> */}
            <ul className='nav-dock-bar nav nav-tabs justify-content-end flex' >
                {data?.map((p, i) =>
                    <li key={p.Id} title={p.Tooltip} className={"nav-item"} > <Link className={ticketId == p.Call_Id.toString() ? "nav-link " + (ticket.StateCssClass || "BlueBG") : "nav-link"} to={`/ticket/${p.Call_Id}`}><Link to={`unpin/${p.Id}`}><Button className='pin-button' size='small' fillMode='flat' imageUrl='./images/pin-dock-white.png' /></Link>{p.Call_Id}</Link></li>
                )}
            </ul>
        </div>
    );
};

export default Dockbar;